<template>
  <div>
    <p>Cool event here! {{ event.event.id }}</p>
    <template v-if="event.timeText">
      <b>{{ event.timeText }}</b>
    </template>
    <i>{{ event.event.title }}</i>
  </div>
</template>

<script>
export default {
  name: "CalendarItem",
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
}
</script>

<style scoped>

</style>
